import { render, staticRenderFns } from "./bug_report.vue?vue&type=template&id=a785fa3c&scoped=true"
import script from "./bug_report.vue?vue&type=script&lang=js"
export * from "./bug_report.vue?vue&type=script&lang=js"
import style0 from "./bug_report.vue?vue&type=style&index=0&id=a785fa3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a785fa3c",
  null
  
)

export default component.exports